/**
 * Returns a display-safe label from a full name string.
 *
 * Rules:
 * - Extract the first word (first name)
 * - If ≤ 12 chars: return first name as-is  (personal, avoids full name)
 * - If > 12 chars: return initials of all words (e.g. "AW", "AMJ")
 *
 * Examples:
 *   "Martin"                              → "Martin"
 *   "Martin Jespersen"                   → "Martin"
 *   "Martin Middlename Jespersen"        → "Martin"
 *   "aVeryLoooooooongName"               → "A"
 *   "aVeryLoooooooongName WithLongLast"  → "AW"
 */
export function formatDisplayName(fullName: string): string {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  const firstName = words[0];
  if (firstName.length <= 12) return firstName;
  return words.map((w) => w[0].toUpperCase()).join('');
}
